/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-03 22:26:38
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import Modal from "src/types/iview/Modal";
import Button from "src/types/iview/Button";
import Input from "src/types/iview/Input";
import {Toast} from "src/util/toast";
import {modalFactory} from "src/util/vueExtend";
import EnumOperates from "src/enums/enumOperates";
import { Integer } from 'src/types/base';
import MeasureTypeApi from './api/measureTypeApi';
import UnitGroupApi from './api/unitGroupApi';
import { createNamespace } from 'src/util/bem';

export namespace OperateUnitVOI {
	export interface PropsI {
		operate: string
        id?: number
        type: string
        name: string
		saveSuccess? (): void

		cancel? (): void
	}

	export interface FormDataI {
		id?: Integer
		"name":string,
	}
}

@Component
class OperateUnitModal extends Vue.Component<OperateUnitVOI.PropsI> {
	@Prop({
		type: Function
	})
	cancel!: () => void

	@Prop({
		type: Number
	})
	id!: number

	@Prop({
		type: String
	})
    operate!: string

    @Prop({
		type: String
	})
    name!: string
    
    @Prop({
		type: String
	})
	type!: string

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

	formData: OperateUnitVOI.FormDataI = {
		name: '',
	}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
	}

	async save () {
		if(!await this.$validate('formValidate')) {
			return
		}
		let res
		this.loading = true
		switch (this.operate) {
			case EnumOperates.Add.getName():
				if(this.type==='测量类型') {
                    res = await MeasureTypeApi.add(this.formData.name)
                } else{
                    res = await UnitGroupApi.add(this.formData.name)
                }
				break
			case EnumOperates.Update.getName():
				if(this.type==='测量类型') {
                    res = await MeasureTypeApi.update(this.formData.name,this.id)
                } else{
                    res = await UnitGroupApi.update(this.formData.name,this.id)
                }
				break
		}
		this.loading = false
		let {code} = res
		if (code === 0) {
			Toast.success(this.operate+'成功')
			this.saveSuccess()
			this.closeModal()
		}
    }
    mounted() {
        if(this.operate === EnumOperates.Update.getName()) {
            this.formData.name = this.name
            this.formData.id = this.id
        }
    }

	render (h) {
		return (
			<Modal
				title={this.operate+this.type}
				width="500"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
				<i-form class={createNamespace('mt20')} ref="formValidate"  labelWidth={100} model={this.formData} >
					<form-item label="名称"  prop="name" required style="width:80%">
						<Input v-model={this.formData.name} placeholder="请输入名称"></Input>
					</form-item>
				</i-form>
				<div slot="footer">
					<Button type="primary" ghost on-click={this.close}>取消</Button>
					<Button type="primary" on-click={this.save} loading={this.loading}>保存</Button>
				</div>
			</Modal>
		);
	}
}

export default function alertOperateUnitModal (operate: string,type: string, id?: number,name?: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			modalFactory<OperateUnitVOI.PropsI>(OperateUnitModal)({
				id,
                operate,
                type,
                name,
				saveSuccess () {
					resolve(true)
				},
				cancel () {
					resolve(false)
				}
			})
		})
	}
